const riot = require('riot');
import '../components/eki.tag'
riot.tag2('page-markets', '<eki></eki>', '', '', function(opts) {
});
